"use client";

import {MessageCircle, PhoneCall} from "lucide-react";
import {useLocale, useTranslations} from "next-intl";

const WA_NUMBER = "919793463801";

export function MobileStickyCta() {
  const locale = useLocale();
  const t = useTranslations("floating");

  const prefill = locale === "hi" ? t("whatsappPrefillHi") : t("whatsappPrefillEn");
  const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(prefill)}`;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[45] grid grid-cols-2 gap-px border-t border-[var(--clinic-line-strong)] bg-[var(--clinic-line-strong)] p-0 shadow-[0_-8px_30px_-12px_rgba(15,23,42,0.35)] backdrop-blur-md md:hidden dark:bg-[var(--clinic-bg)]"
      role="navigation"
      aria-label={t("mobileBarLabel")}
    >
      <a
        href="tel:+919793463801"
        className="inline-flex min-h-[52px] items-center justify-center gap-2 bg-[var(--clinic-surface)] px-3 text-sm font-bold text-[var(--clinic-accent-strong)] transition active:bg-red-50 dark:active:bg-[var(--clinic-surface-soft)]"
      >
        <PhoneCall className="h-5 w-5 shrink-0" aria-hidden />
        <span className="truncate">{t("mobileCall")}</span>
      </a>
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex min-h-[52px] items-center justify-center gap-2 bg-[#25D366] px-3 text-sm font-bold text-white transition active:bg-[#1ebe5d]"
      >
        <MessageCircle className="h-5 w-5 shrink-0" aria-hidden />
        <span className="truncate">{t("mobileWhatsApp")}</span>
      </a>
    </div>
  );
}
